export interface RecurlyPlan {
    unit: string
    setup_fee: string
}

export interface RecurlyPriceBase {
    addons: { [key: string]: string }
    plan: RecurlyPlan
}
export interface RecurlyPriceNow {
    total: number
    subtotal: number
    plan: number
    discount: number
}
export interface RecurlyPrice {
    base: RecurlyPriceBase
    now: RecurlyPriceNow
    currency: RecurlyPriceCurrency
}
export interface RecurlyPriceCurrency {
    code: string
    symbol: string
}

export enum PaymentInterval {
    Monthly = 1,
    Yearly,
}
